import Clear from './../layouts/Clear.vue';

export default {
    path: '/assets',
    component: Clear,
    children: [
        {
            path: '',
            name: 'assets.index',
            component: () => import('@/views/assets/index.vue'),
        },
        {
            path: 'show/:code',
            name: 'assets.show',
            component: () => import('@/views/assets/showToken.vue'),
            props: true,
            meta: {title: 'Visualizar Token'}
        },
        {
            path: 'replacement/:code',
            name: 'assets.replacement',
            component: () => import('@/views/assets/replacementToken.vue'),
            props: true,
            meta: {title: 'Substituir Token'}
        },
    ],
};
